function getCareerCategorySpecificMeta(categoryName, intl, metaTitle, metaDescription, titleTop, titleBottom) {
  if (categoryName.length) {
    metaTitle = intl.messages['Career.CategoryTitle']
      ? intl.formatMessage({ id: 'Career.CategoryTitle' }, {
        sitename: process.env.REACT_APP_SITENAME,
        category: categoryName,
      })
      : metaTitle;
    metaDescription = intl.messages['Career.CategoryMetaDescriptionTitle']
      ? intl.formatMessage({ id: 'Career.CategoryMetaDescriptionTitle' }, {
        sitename: process.env.REACT_APP_SITENAME,
        category: categoryName,
      })
      : metaDescription;
    titleTop = intl.messages['CareerHeader.CategoryTitleTop']
      ? intl.formatMessage({ id: 'CareerHeader.CategoryTitleTop' }, { category: categoryName })
      : titleTop;
    titleBottom = intl.messages['CareerHeader.CategoryTitleTopBottom']
      ? intl.formatMessage({ id: 'CareerHeader.CategoryTitleTopBottom' })
      : titleBottom;
  }

  return {
    metaTitle,
    metaDescription,
    titleTop,
    titleBottom,
  };
}

export default getCareerCategorySpecificMeta;
